import { Component, OnInit, AfterViewInit, ElementRef, ViewChild } from '@angular/core';
import { RewardsWalletQuery, RewardsWalletService, WalletGroupItem } from '@fgb/core';
import { firstValueFrom, Observable } from 'rxjs';

@Component({
  selector: 'fgb-wallet-page',
  templateUrl: './wallet-page.component.html',
  styleUrls: ['./wallet-page.component.scss'],
})
export class WalletPageComponent implements OnInit, AfterViewInit {
  walletItems$: Observable<WalletGroupItem[]>;

  isBarcodeCollapsed = false;
  isDragging = false;
  dragBarcodeHeight: number | null = null;

  @ViewChild('barcodeWrapper') barcodeWrapper!: ElementRef<HTMLElement>;

  private dragStartY = 0;
  private barcodeNaturalHeight = 250;
  private readonly SNAP_RATIO = 0.4;

  constructor(private rewardsWalletQuery: RewardsWalletQuery, private rewardsWalletService: RewardsWalletService) {}

  async ngOnInit() {
    firstValueFrom(this.rewardsWalletService.fetchWalletItems());
    this.walletItems$ = this.rewardsWalletQuery.selectGroupedUnredeemedWalletItems();
  }

  ngAfterViewInit(): void {
    if (this.barcodeWrapper) {
      this.barcodeNaturalHeight = this.barcodeWrapper.nativeElement.scrollHeight;
    }
  }

  onHandleTouchStart(event: TouchEvent): void {
    this.isDragging = true;
    this.dragStartY = event.touches[0].clientY;
    this.barcodeNaturalHeight = this.barcodeWrapper.nativeElement.scrollHeight || this.barcodeNaturalHeight;
    this.dragBarcodeHeight = this.isBarcodeCollapsed ? 0 : this.barcodeNaturalHeight;
  }

  onHandleTouchMove(event: TouchEvent): void {
    if (!this.isDragging) return;
    const delta = event.touches[0].clientY - this.dragStartY;
    const base = this.isBarcodeCollapsed ? 0 : this.barcodeNaturalHeight;
    this.dragBarcodeHeight = Math.max(0, Math.min(this.barcodeNaturalHeight, base + delta));
  }

  onHandleTouchEnd(): void {
    if (!this.isDragging) return;
    this.isDragging = false;
    const ratio = (this.dragBarcodeHeight ?? 0) / this.barcodeNaturalHeight;
    this.isBarcodeCollapsed = ratio < this.SNAP_RATIO;
    this.dragBarcodeHeight = null;
  }
}
